import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canListCoach } from "@/lib/roles";
import Logo from "@/components/Logo";

export default function Footer() {
  const { user } = useAuth();
  const showListCoach = !user || canListCoach(user);
  return (
    <footer className="mt-32 border-t border-ivory-400 bg-ivory-200">
      <div className="container-editorial py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <Logo variant="master-black" height={40} />
          </div>
          <p className="font-serif italic text-2xl text-ink-50 leading-tight max-w-md">
            &ldquo;Born in luxury coaches. Connected across luxury travel.&rdquo;
          </p>
          <p className="text-sm text-ink-100 mt-6 max-w-md leading-relaxed">
            The luxury travel marketplace &mdash; built on deep expertise in luxury motorcoaches,
            entertainer coaches and premium motorhomes, and connected across private aviation and
            luxury marine through trusted specialists.
          </p>
          <p className="text-[10px] uppercase tracking-[0.28em] text-ink-100 mt-6">
            Land · Air · Water &nbsp;·&nbsp; Marketplace · Passport · Auctions
          </p>
        </div>

        <div>
          <h4 className="overline mb-5">Marketplace</h4>
          <ul className="space-y-3 text-sm text-ink-50">
            <li><Link to="/browse" className="hover:text-copper transition-colors">Browse Coaches</Link></li>
            <li><Link to="/browse?coach_type=Luxury%20Motorhome" className="hover:text-copper transition-colors">Luxury Motorhomes</Link></li>
            <li><Link to="/browse?coach_type=Entertainer%20Coach" className="hover:text-copper transition-colors">Entertainer Coaches</Link></li>
            <li><Link to="/browse?converter=Marathon%20Coach" className="hover:text-copper transition-colors">Marathon Conversions</Link></li>
            <li><Link to="/browse?converter=Liberty%20Coach" className="hover:text-copper transition-colors">Liberty Conversions</Link></li>
            <li className="pt-2 mt-1 border-t border-ivory-400">
              <Link to="/marketplace/private-aviation" className="hover:text-copper transition-colors" data-testid="footer-private-aviation">Private Aviation</Link>
            </li>
            <li><Link to="/marketplace/luxury-marine" className="hover:text-copper transition-colors" data-testid="footer-luxury-marine">Luxury Marine</Link></li>
          </ul>
          <p className="text-[10px] text-ink-100 mt-3 leading-relaxed">Air &amp; Water — through trusted specialists</p>
        </div>

        <div>
          <h4 className="overline mb-5">Trust & Company</h4>
          <ul className="space-y-3 text-sm text-ink-50">
            <li><Link to="/trust" className="hover:text-copper transition-colors">Vanturis Verified</Link></li>
            <li><Link to="/trust" className="hover:text-copper transition-colors">Vanturis Certified</Link></li>
            <li><Link to="/trust" className="hover:text-copper transition-colors">Vanturis Passport</Link></li>
            <li><Link to="/become-a-partner" className="hover:text-copper transition-colors" data-testid="footer-become-a-partner">Become a Partner</Link></li>
            <li><Link to="/sell" className="hover:text-copper transition-colors">Sell a Coach</Link></li>
            {showListCoach && (
              <li><Link to="/list-coach" className="hover:text-copper transition-colors">List Your Coach</Link></li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory-400">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="flex flex-col gap-2">
            <p className="text-xs text-ink-100 tracking-wider">
              © {new Date().getFullYear()} Vanturis. The luxury travel marketplace — born in luxury coaches, connected across land, air &amp; water.
            </p>
            <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-ink-100" aria-label="Legal">
              <Link to="/legal/privacy" className="hover:text-copper transition-colors" data-testid="footer-legal-privacy">Privacy Policy</Link>
              <span aria-hidden="true">·</span>
              <Link to="/legal/terms" className="hover:text-copper transition-colors" data-testid="footer-legal-terms">Terms of Use</Link>
              <span aria-hidden="true">·</span>
              <Link to="/legal/listing-disclaimer" className="hover:text-copper transition-colors" data-testid="footer-legal-disclaimer">Listing Disclaimer</Link>
            </nav>
          </div>
          <p className="text-[10px] uppercase tracking-[0.28em] text-ink-100">
            Prevost · Marathon · Liberty · Newell · MCI · Millennium
          </p>
        </div>
      </div>
    </footer>
  );
}
